import { JSX } from 'react'

import OtherIcon from '../../assets/logo/Other.svg'

const OtherHomeCustomIcon = (): JSX.Element => <img src={OtherIcon} alt="logo" />

export default OtherHomeCustomIcon
